import React 			from 'react';
import moment from 'moment';
import BLComponent		from '../../core/_BLComponent.jsx';

import {returnSeriesDates} from './_BDPUtilities.jsx';


export default class SeriesInternalNav extends BLComponent {
	constructor (props, context) {
		super(props, context);
		this.seriesNumber = parseInt(blapp.util.getUrlInfo(window.location.href).path.split('/')[3].split('-')[1]); 
		this.series = blapp.models.get('listSeries') || [];
	}

	componentDidMount() {
		const overflowNav = this.overflowNav;
		const activeItem = overflowNav.querySelector('.bdp-series-main__series-nav-item--active');

		if(activeItem) {
			overflowNav.scrollLeft = activeItem.offsetLeft - (activeItem.offsetWidth * 0.5);
		}
	}

	render() {
		const {classes = ''} = this.props;
		const today = blapp.config.server_time;
		const archivedSeries = this.series.filter(series => today >= moment(series.udtProductionStart).add(6, 'months'));
		const activeSeries = this.series.filter(series => today < moment(series.udtProductionStart).add(6, 'months'));

		const navItems = activeSeries.reverse().map((series, idx) => {
			return (
				<a key={idx} href={blapp.url2.getCrowdSeriesUrl(series.strSlug)} className={`bdp-series-main__series-nav-item ${this.seriesNumber == series.idSeries ? 'bdp-series-main__series-nav-item--active' : ''}`}>
					<i className={`bdp-series-main__series-nav-icon ${this.returnSeriesIcon(series.idSeries)} fa-fw`}/>
					<strong>{series.strName}</strong>
				</a>
			);
		});

		const navOptions = this.series.map((series, idx) => {
			return (
				<option key={idx} disabled={this.seriesNumber == series.idSeries} value={series.idSeries}>{series.strName}</option>
			);
		});

		return (
			<div className={`text--center ${classes}`}>
				<section ref={(overflowNav) => this.overflowNav = overflowNav} className="bdp-series-main__series-nav bdp-series-main__series-nav-desktop">
					{navItems}
					{archivedSeries.length ?
						<a href={blapp.url2.getCrowdPastSeriesUrl()} className={`bdp-series-main__series-nav-item l-pad-left`}>
							<strong>Past Series</strong>
							<i className="fas fa-chevron-right l-margin-left"/>
						</a>
					: null}
				</section>
				<label htmlFor="bdp-series-select" className="bdp-series-main__series-nav bdp-series-main__series-nav-mobile">
					<select className="bdp-series-main__series-nav-item bdp-series-main__series-nav-item--mobile" id="bdp-series-select" value={this.seriesNumber} onChange={(e) => this.selectSeries(e.target.value)}>
						<option disabled={true} selected={!this.seriesNumber}>Go to Series...</option>
						{navOptions}
						{archivedSeries.length ? 
							<React.Fragment>
								<option disabled>──────────</option>
								<option value="past">Past series</option>
							</React.Fragment>
						: null}
					</select>
				</label>
			</div>
		);
	}

	returnSeriesIcon(seriesNumber) {
		const currentDate = blapp.config.server_time;
		const seriesContent = this.series[this.series.findIndex(series => series.idSeries == seriesNumber)];
		const seriesDates = returnSeriesDates(seriesContent);

		const icons = ["fal fa-pen-ruler", "fal fa-paper-plane", "fal fa-check-to-slot", "fal fa-list-check", "fal fa-megaphone", "fal fa-screwdriver-wrench", "fal fa-circle-dollar-to-slot", "fal fa-cart-flatbed"];
		let icon = 'fal fa-megaphone';

		for(let i = seriesDates.length - 1; i >= 0; i--) {
			if(currentDate >= seriesDates[i].dates.start) {
				icon = icons[i];

				break;
			}
		}

		return icon;
	}

	selectSeries(value) {
		if(value == 'past') {
			window.location = blapp.url2.getCrowdPastSeriesUrl();
		}else{
			const seriesIdx = this.series.findIndex(series => series.idSeries == value); 
			const url = blapp.url2.getCrowdSeriesUrl(this.series[seriesIdx].strSlug);
			
			window.location = url;
		}
	}
}